import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ROUTES } from '@app/app.routes-constants';
import { SelectionService } from '@app/grouped-invoice/shared/services/selection.service';

/**
 * Guard that ensures there is at least one selected item before accessing the submit group invoice route.
 * If the selection is empty, it redirects to the create group invoice route.
 */
export const createGroupedInvoiceGuard: CanActivateFn = () => {
  const router = inject(Router);
  const selectionService = inject(SelectionService) as SelectionService<unknown>;

  const hasSelection = selectionService.selection.selected.length > 0;

  return hasSelection ? true : router.createUrlTree([ROUTES.GROUPED_INVOICE.GROUP]);
};
